import { useReframe } from 'nike-re-framejs';
import { isPickSelected$$ } from './subs';
import { addPick, removePick } from './command';
import { betLocation } from '../../common/BetLocationContext';

export const useBetslipPick = ({
    betId,
    selectionCode,
    odds,
    positionId = betLocation.DEFAULT_POSITION.id,
    positionCode = betLocation.DEFAULT_POSITION.code,
    ...rest
}) => {
    const derefSub = useReframe();
    const { isSelected } = derefSub(isPickSelected$$(`${betId}-${selectionCode}`));
    return {
        isSelected,
        addPick: e => {
            e?.stopPropagation();
            e?.preventDefault();
            addPick({ betId, selectionCode, positionCode, positionId, odds, ...rest });
        },
        removePick: e => {
            e?.stopPropagation();
            e?.preventDefault();
            removePick({ betId });
        }
    };
};
